import { FormattedMessage } from 'react-intl';

export const NoValue = (props: { messageId?: string }) => (
    <div className="NoData">
        <FormattedMessage id={props.messageId ?? 'outboundOrderBook.common.noData'} />
    </div>
);
